/*
 * @Author: wangxiang 
 * @Date: 2019-11-11 13:42:06 
 * @Last Modified by: wangxiang
 * @Last Modified time: 2019-11-11 17:20:33
 */
export default {
  name: 't-text',
  render (h) {
    const {
      text,
      fontFamily,
      maxLength,
      canInput,
      textAlign
    } = this;
    const style = {
      position: 'relative',
      fontFamily,
      lineHeight: 1.4
    };
    const inputStyle = {
      width: "100%",
      height: '100%',
      padding: "3px 3px",
      border: "0 none",
      resize: 'none',
      textAlign,
      lineHeight: 1.4
    };

    return (
      <div
        onDblclick={e => {
          if (!canInput) {
            return false;
          }
          this.canEdit = true;
          e.stopPropagation();
        }}
        onMousedown={e => {
          if (this.canEdit) { e.stopPropagation(); }
        }}
        v-click-outside={(e) => {
          this.canEdit = false;
        }}
        style={style}
      >
        {
          this.canEdit
            ? <textarea
              style={inputStyle}
              value={text}
              maxLength={maxLength}
              onChange={(evt) => {
                this.$emit('input', {
                  value: evt.target.value,
                  pluginName: 't-text'
                });
              }}>
            </textarea>
            : <pre style={style}>{text}</pre>
        }
      </div>
    )
  },
  data () {
    return {
      canEdit: false
    }
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    fontFamily: {
      type: String,
      default: ''
    },
    canInput: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    textAlign: {
      type: String,
      default: 'center'
    },
    maxLength: {
      type: Number,
      default: 10
    }
  },
  editorConfig: {
    propsConfig: {
      maxLength: {
        type: 'a-input',
        label: '输入字数限制',
        require: true,
        default: 10
      },
      fontFamily: {
        type: 'a-input',
        label: '字体',
        require: true,
        defaultPropValue: ''
      },
      canInput: {
        type: 'a-radio',
        label: '是否可输入',
        require: true,
        defaultPropValue: true
      },
      textAlign: {
        type: 'a-radio',
        label: '对齐方式',
        require: false,
        defaultPropValue: 'center'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/module/album/plugins/t-text.js